import React, { useContext } from 'react';
import { StateContext } from "../../state";
import { get } from 'lodash/object';

export const Title = ({children}) => {
  const [{configuration}] = useContext(StateContext);

  return (
    <section className="title" {...get(configuration, 'title.props', {})}>
      {children}
    </section>
  );
};

export default Title;
